function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.6
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint0_linear)",
  d: "M37.0647 1.56914C31.0214 -0.397898 24.5342 2.89687 22.5685 8.9375C20.6015 14.9808 23.9029 21.4666 29.9382 23.4283C35.9775 25.398 42.4647 22.1006 44.4317 16.0613C46.3974 10.0153 43.1 3.53483 37.0647 1.56914Z",
  clipRule: "evenodd",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint1_linear)",
  d: "M36.2943 3.08412C31.091 1.39221 25.5063 4.23246 23.8091 9.43042C22.1171 14.6324 24.9587 20.2211 30.158 21.9104C35.36 23.6076 40.9501 20.7687 42.6406 15.5681C44.3352 10.3621 41.495 4.78002 36.2943 3.08412Z",
  clipRule: "evenodd",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint2_linear)",
  d: "M41.1887 11.6541L38.5492 7.09004C38.528 7.02758 38.4894 6.97441 38.4402 6.92123C38.3126 6.74314 38.096 6.63281 37.8647 6.63281C37.6281 6.63281 37.4368 6.74314 37.2852 6.91592L37.1802 7.09536L34.3373 12.0275L34.2084 12.2548C34.1925 12.3279 34.1633 12.4103 34.1633 12.498C34.1633 12.5884 34.1925 12.6655 34.2084 12.7492L34.3373 12.9672L35.9601 15.7848C36.0412 15.9031 36.0625 16.028 36.0625 16.1476C36.0625 16.4002 35.9389 16.6447 35.701 16.7816C35.3554 16.9876 34.9035 16.8653 34.7095 16.5158L33.8748 15.103L33.8177 14.986C33.6888 14.8079 33.4681 14.6856 33.2249 14.6856C32.9857 14.6856 32.7637 14.8079 32.6375 14.986L32.579 15.103L30.5083 18.6622L30.5016 18.6888C30.4392 18.8005 30.3887 18.9347 30.3887 19.0769C30.3887 19.4783 30.7249 19.8092 31.1263 19.8092H36.4691C36.9954 19.8092 37.668 19.4304 37.9205 18.9666L41.1887 13.342C41.4492 12.8821 41.4492 12.1166 41.1887 11.6541Z",
  clipRule: "evenodd",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint3_linear)",
  d: "M32.2394 12.7492C32.258 12.6655 32.2912 12.5884 32.2912 12.498C32.2912 12.405 32.2593 12.3279 32.2394 12.2548L32.1171 12.0275L30.4903 9.21523C30.4106 9.09294 30.3867 8.9627 30.3867 8.84573C30.3867 8.5932 30.5116 8.33934 30.7482 8.2091C31.0964 8.00841 31.5429 8.12802 31.745 8.48288L32.577 9.88637L32.6355 10.0073C32.7617 10.1934 32.9837 10.3157 33.2229 10.3157C33.4661 10.3157 33.6867 10.1921 33.8157 10.0073L33.8728 9.88771L35.9409 6.32716L35.9501 6.30854C36.0153 6.19558 36.0644 6.05602 36.0644 5.91114C36.0644 5.50975 35.7282 5.18945 35.3454 5.18945H29.9747C29.455 5.18945 28.7838 5.56159 28.5286 6.02941L25.2658 11.6527C25 12.1152 25 12.8808 25.2658 13.3406L27.9027 17.9046C27.9319 17.9657 27.9625 18.0255 28.0064 18.076C28.1406 18.2515 28.3559 18.3684 28.5911 18.3684C28.8158 18.3684 29.0191 18.2555 29.164 18.0813L29.2743 17.8993L32.1145 12.9671L32.2394 12.7492Z",
  clipRule: "evenodd",
  fillRule: "evenodd"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint4_linear)",
  d: "M28.9876 13.2873C29.0041 13.0965 29.0041 12.896 28.9876 12.6997C28.9547 12.2604 28.8462 11.8308 28.6568 11.493L23.9632 3.38805C23.9358 3.31256 23.8822 3.24804 23.8355 3.18214L22.854 1.49086C22.4023 0.669935 21.2053 0 20.2759 0H18.2689H10.7322H8.72378C7.79715 0 6.59868 0.669935 6.14701 1.49086L5.16685 3.18214C5.1188 3.24942 5.06525 3.31394 5.0392 3.38805L0.344205 11.493C0.160246 11.8225 0.0517816 12.2412 0.0133643 12.6723C-0.00448271 12.8865 -0.00448271 13.1033 0.0133643 13.3216C0.050441 13.7527 0.158864 14.1659 0.344205 14.4954L1.60992 16.6726L5.03781 22.6113C5.08587 22.7239 5.14351 22.8282 5.22588 22.9202C5.23413 22.934 5.24921 22.9422 5.25747 22.9573L6.15392 24.4962C6.60421 25.3226 7.79715 25.9981 8.73752 25.9981H10.761H18.24H20.2635C21.2039 25.9981 22.3996 25.3226 22.8485 24.4962L23.745 22.9573C23.7546 22.9408 23.7669 22.9326 23.7779 22.9202C23.8603 22.8296 23.9179 22.7239 23.9646 22.6113L27.3925 16.6726L28.6582 14.4954C28.8462 14.159 28.9533 13.7321 28.9876 13.2873Z",
  clipRule: "evenodd",
  fillRule: "evenodd"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint5_linear)",
  d: "M26.8439 13.2463C26.859 13.0843 26.859 12.9127 26.8439 12.7466C26.8165 12.3705 26.7245 12.004 26.5611 11.717L22.5636 4.81046C22.5402 4.74732 22.4936 4.69101 22.4538 4.63747L21.6177 3.1919C21.2333 2.49315 20.212 1.9248 19.4212 1.9248H17.7121H11.2888H9.57687C8.78615 1.9248 7.76614 2.49315 7.38176 3.1919L6.5471 4.63747C6.50592 4.69101 6.45925 4.74728 6.43729 4.81046L2.43695 11.717C2.28182 11.9984 2.1871 12.3554 2.15689 12.7219C2.14043 12.9045 2.14043 13.0898 2.15689 13.2765C2.1871 13.6416 2.28182 13.9945 2.43695 14.2745L3.51461 16.1305L6.43591 21.1934C6.47848 21.2895 6.52653 21.376 6.59653 21.4556C6.6034 21.4652 6.61576 21.4721 6.62397 21.4844L7.38725 22.7968C7.77163 23.4997 8.78749 24.0749 9.58923 24.0749H11.3121H17.6846H19.4075C20.2092 24.0749 21.2278 23.4997 21.6095 22.7968L22.3741 21.4844C22.3824 21.4707 22.3934 21.4638 22.4016 21.4556C22.4716 21.3746 22.5196 21.2895 22.5622 21.1934L25.4822 16.1305L26.5584 14.2745C26.7245 13.9877 26.8165 13.6238 26.8439 13.2463Z",
  clipRule: "evenodd",
  fillRule: "evenodd"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint6_linear)",
  d: "M19.8382 11.4796L16.0232 11.4768V7.66181C16.0232 6.82165 15.3409 6.13525 14.4994 6.13525C13.6578 6.13525 12.9756 6.82165 12.9756 7.66181V11.4741H9.16193H9.15916C8.31901 11.4741 7.63672 12.155 7.63672 12.9951C7.63672 13.8408 8.31763 14.5189 9.15916 14.5189L12.9755 14.5217V18.3367C12.9755 19.1796 13.6592 19.8605 14.4993 19.8605C15.3422 19.8605 16.0231 19.1796 16.0231 18.3367V14.5244H19.8381C20.6796 14.5244 21.3633 13.8435 21.3633 13.0034C21.3647 12.1591 20.681 11.4796 19.8382 11.4796Z",
  clipRule: "evenodd",
  fillRule: "evenodd"
});

var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  gradientUnits: "userSpaceOnUse",
  y2: -13.1,
  x2: 23.3443,
  y1: -18.994,
  x1: 76.1551,
  id: "paint0_linear"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#17E2CF"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5181FD",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  gradientUnits: "userSpaceOnUse",
  y2: -7.78356,
  x2: 8.68813,
  y1: -12.861,
  x1: 54.1731,
  id: "paint1_linear"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#173048"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5181FD",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  gradientUnits: "userSpaceOnUse",
  y2: 21.5126,
  x2: 33.8112,
  y1: 9.38388,
  x1: 24.3427,
  id: "paint2_linear"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#17E2CF"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5181FD",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  gradientUnits: "userSpaceOnUse",
  y2: 22.3091,
  x2: 32.3399,
  y1: 10.1819,
  x1: 22.8733,
  id: "paint3_linear"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#17E2CF"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5181FD",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  gradientUnits: "userSpaceOnUse",
  y2: 2.25199,
  x2: 46.1278,
  y1: 43.7191,
  x1: 23.7161,
  id: "paint4_linear"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5181FD"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#17E2CF",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  gradientUnits: "userSpaceOnUse",
  y2: 16.018,
  x2: 33.2596,
  y1: 51.3511,
  x1: 14.1678,
  id: "paint5_linear"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#173048"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5181FD",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  gradientUnits: "userSpaceOnUse",
  y2: 31.8071,
  x2: -3.4393,
  y1: 7.65239,
  x1: 2.99013,
  id: "paint6_linear"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#17E2CF"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5181FD",
  offset: 1
})));

var SvgIconAddCollateral = function SvgIconAddCollateral(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 45 26",
    height: 26,
    width: 45,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconAddCollateral, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Icon_Add_Collateral.7b72783d.svg";
export { ForwardRef as ReactComponent };